import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, OnDestroy, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { Location } from '@angular/common';
import { SharedService } from './shared.service';
import { JobCatsOne } from './vacancy-data.component';
import { employmentTypes, Utils } from "./utils"
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { JobDescriptionFormatterService } from './services/job-description-formatter.service';
import { BreadcrumbsService } from './services/breadcrumbs.service';
import { SeoService } from './services/seo.service';
import { environment } from 'client/environments/environment';
import { AnalyticsService } from './services/analytics.service';
import { VacancyMetaService } from './services/vacancy-meta.service';

@Component({
    selector: 'view-job',
    templateUrl: './view-job.component.html',
    styleUrls: ['./view-job.component.scss'],
    standalone: false
})
export class ViewJobComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("spinnerRef") spinnerRef: ElementRef
  @ViewChild("viewJobRef") viewJobRef: ElementRef
  @ViewChild("notAvailableRef") notAvailableRef: ElementRef
  @ViewChild("vacancyRef") vacancyRef: ElementRef
  @ViewChild("buttonsRef") buttonsRef: ElementRef
  @ViewChild("recruiterRef") recruiterRef: ElementRef
  @ViewChild("relatedJobsTitleRef") relatedJobsTitleRef: ElementRef
  @ViewChildren("relatedJobsContainerRef") relatedJobsContainerRef: QueryList<any>
  
  public job: JobCatsOne
  public relatedJobs: JobCatsOne[] = []
  public isLoadingJob = true
  public isLoadingRelatedJobs = true
  public isMobile = false
  public jsonLD: SafeHtml; // deprecated (template script removed)
  public formattedDescription: SafeHtml;
  public isPublished = true
  public time = 5
  public relatedVacanciesToggle = "publicationDate"
  public relatedVacanciesToggleDisplay = "Publicatie datum"
  public mediaQuery1400: MediaQueryList
  public dateToDatePosted = Utils.dateToDatePosted
  public parseJobDescription = Utils.parseJobDescription
  public phoneCall = Utils.phoneCall
  public email = Utils.email
  public parseSalary = Utils.parseSalary
  public parseHours = Utils.parseHours
  public mapIndustries = Utils.mapIndustries
  public whatsapp = Utils.whatsapp
  private interval: any

  // Minimal country code to flag map for common cases; defaults to 🇳🇱 (+31)
  private readonly countryCodeToFlag: Record<string, string> = {
    '1': '🇺🇸', // NANP
    '31': '🇳🇱',
    '32': '🇧🇪',
    '33': '🇫🇷',
    '34': '🇪🇸',
    '39': '🇮🇹',
    '41': '🇨🇭',
    '43': '🇦🇹',
    '44': '🇬🇧',
    '45': '🇩🇰',
    '46': '🇸🇪',
    '47': '🇳🇴',
    '48': '🇵🇱',
    '49': '🇩🇪',
    '351': '🇵🇹',
    '352': '🇱🇺',
    '353': '🇮🇪'
  }

  public constructor(
    private readonly router: Router,
    private activatedRoute: ActivatedRoute,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    public sharedService: SharedService,
    private readonly breadcrumbsService: BreadcrumbsService,
    private readonly seo: SeoService,
    private readonly vacancyMeta: VacancyMetaService,
    private readonly location: Location,
  private readonly jdFormatter: JobDescriptionFormatterService,
  private readonly analytics: AnalyticsService,
  private readonly cdr: ChangeDetectorRef,
  ) {}

  public onRelatedVacanciesToggleChange(displayValue: string) {
    this.relatedVacanciesToggleDisplay = displayValue
    // Map display value to internal value
    this.relatedVacanciesToggle = displayValue === "Publicatie datum" ? "publicationDate" : "alphabetic"
    
    if (this.relatedVacanciesToggle === "publicationDate") {
      this.sortRelatedJobsByTime()
    } else {
      this.relatedJobs.sort((a, b) => a.title.localeCompare(b.title))
    }
  }

  private sortRelatedJobsByTime() {
    this.relatedJobs.sort((a, b) => new Date(b.publicationDate).getTime() - new Date(a.publicationDate).getTime())
  }

  public ngOnInit(): void {
    this.mediaQuery1400 = window.matchMedia("(min-width: 1401px)")
    this.mediaQuery1400.addListener((_) => {
      this.updateRelatedJobContainerHeight()
    })
    window.addEventListener("resize", (_) => {
      this.updateRelatedJobContainerHeight()
    })
    window.scrollTo(0, 0)
    this.titleService.setTitle("Blauwtand — Vacature")
    this.seo.updateSeo({ title: 'Vacature' })
    this.jsonLD = this.defaultJsonLD
    if(!this.sharedService.selectedJobId) {
      this.activatedRoute.params.subscribe(params => {
        const paramId = params?.["id"]
        const slugId = params?.["id"] ?? params?.["slug"] ?? params?.["slug-:id"]
  // Support legacy English paths via redirects; new primary paths use Dutch segments
        const idFromSlug = String(slugId || '').match(/^(?:.+-)?(\d+)$/)?.[1]
        const id = Number(idFromSlug ?? paramId)
        if (!Number.isFinite(id)) {
          // Invalid or missing id; show not-available state without fetching
          this.isLoadingJob = false
          this.isPublished = false
          return
        }
        this.getJob(id)
      })
    } else {
      this.getJob(this.sharedService.selectedJobId)
    }
  }

  public async ngAfterViewInit(): Promise<void> {
    this.relatedJobsContainerRef.changes.subscribe(_ => {
      this.updateRelatedJobContainerHeight()
    })

    await Utils.timeout()
    if(window.innerWidth <= 767 ) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
    window.addEventListener("scroll", () => {
      this.scrollFade()
    })
    this.scrollFade()
  }

  private updateRelatedJobContainerHeight() {
    const viewJobElement = this.vacancyRef.nativeElement as HTMLDivElement
    const viewJobElementRect = viewJobElement.getBoundingClientRect()
    if (!this.recruiterRef) { return }
    const recruiterElement = this.recruiterRef.nativeElement as HTMLDivElement
    const recruiterElementRect = recruiterElement.getBoundingClientRect()
    const relatedJobsTitleElement = this.relatedJobsTitleRef.nativeElement as HTMLDivElement
    const relatedJobsTitleElementRect = relatedJobsTitleElement.getBoundingClientRect()
    const relatedJobsElement = (this.relatedJobsContainerRef.toArray()?.[0] as ElementRef)?.nativeElement as HTMLDivElement
    if (this.mediaQuery1400.matches) {
      relatedJobsElement.style.maxHeight = `${viewJobElementRect.height - recruiterElementRect.height - relatedJobsTitleElementRect.height - 32 - 16}px`
    } else {
      relatedJobsElement.style.maxHeight = '500px'
    }

  }
 
  public get countdown(): number {
    return this.time <= 0 ? 0 : this.time
  }

  // Formats a phone number to display with flag and space between country code and subscriber number
  public formatPhoneDisplay(rawPhone: string): string {
    if (!rawPhone) { return 'Niet beschikbaar' }
    const { countryCode, subscriberNumber, flag } = this.splitPhoneNumber(rawPhone)
    return `${flag} +${countryCode} ${subscriberNumber}`
  }

  // Formats a phone number to E.164 for tel: links and calls (e.g., +31612345678)
  public formatE164(rawPhone: string): string {
    if (!rawPhone) { return '' }
    const { countryCode, subscriberNumber } = this.splitPhoneNumber(rawPhone)
    return `+${countryCode}${subscriberNumber.replace(/^0+/, '')}`
  }

  // Helpers for template to separate flag and number display
  public getPhoneFlag(rawPhone: string): string {
    if (!rawPhone) { return '' }
    const { flag } = this.splitPhoneNumber(rawPhone)
    return flag
  }

  public getPhoneDisplay(rawPhone: string): string {
    if (!rawPhone) { return '' }
    const { countryCode, subscriberNumber } = this.splitPhoneNumber(rawPhone)
    return `+${countryCode} ${subscriberNumber}`
  }

  // Returns phone number formatted for WhatsApp API (E.164 without '+')
  public toWhatsAppNumber(rawPhone: string): string {
    const e164 = this.formatE164(rawPhone)
    return e164.startsWith('+') ? e164.slice(1) : e164
  }

  private splitPhoneNumber(rawPhone: string): { countryCode: string, subscriberNumber: string, flag: string } {
    const defaultCountryCode = '31'
    const defaultFlag = this.countryCodeToFlag[defaultCountryCode]
    let cleaned = String(rawPhone).trim()
      .replace(/\s+/g, '')
      .replace(/[()\-]/g, '')

    // Normalize leading 00 to +
    if (cleaned.startsWith('00')) {
      cleaned = `+${cleaned.slice(2)}`
    }

    let digits = cleaned
    if (digits.startsWith('+')) { digits = digits.slice(1) }

    // Try to find a known country code (prefer 3, then 2, then 1 digit)
    const candidates = [digits.slice(0, 3), digits.slice(0, 2), digits.slice(0, 1)].filter(Boolean)
    let countryCode = candidates.find(code => this.countryCodeToFlag[code])
    let subscriberNumber = ''

    if (countryCode) {
      subscriberNumber = digits.slice(countryCode.length)
    } else {
      // Fallback: assume NL if no explicit code
      countryCode = defaultCountryCode
      subscriberNumber = digits
    }

    // Ensure subscriber number is digits only
    subscriberNumber = subscriberNumber.replace(/[^0-9]/g, '')

    const flag = this.countryCodeToFlag[countryCode] ?? defaultFlag
    return { countryCode, subscriberNumber, flag }
  }

  public getJob(id: number) {
    this.httpClient.get(`${Utils.getApiUrl()}/jobs/${id}`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).subscribe({
      next: response => {
        const typedResponse = (response as { job: any, recruiter: any})

        // Publish state impacts robots and whether we emit JobPosting JSON-LD.
        this.isPublished = !!typedResponse.job?.is_published

        if(Object.keys(typedResponse.job).length > 0) {
          try {
            this.job = Utils.parseJob(typedResponse)
            this.parseGoogleJob()
            this.formattedDescription = this.jdFormatter.format(this.job.description || '', { demoteHeadings: true, linkify: true })
            // Update breadcrumb leaf to job title
            if (this.job?.title) {
              this.breadcrumbsService.setCurrentLeafLabel(this.job.title)
            }
            // Update SEO with job-specific info + JSON-LD
            this.setSeoForJob(this.job)

            // Consolidate legacy variants (/vacatures/<id>, /vacatures/bekijk-vacature/<id>)
            // to the canonical slug+id URL without triggering a second fetch.
            this.maybeReplaceUrlWithCanonicalJobUrl(this.job)

            this.httpClient.get(`${Utils.getApiUrl()}/relatedJobs/${id}`, {
              headers: new HttpHeaders({
                "Content-Type": "application/json"
              }),
              params: { title: this.job.title }
            }).subscribe({
              next: r => {
                const relatedJobs = (r as { relatedJobs: any[] })
                this.relatedJobs = relatedJobs?.relatedJobs ?? []
                this.sortRelatedJobsByTime()
                this.isLoadingRelatedJobs = false
                this.cdr.markForCheck()
              },
              error: _ => {
                this.relatedJobs = []
                this.isLoadingRelatedJobs = false
                this.cdr.markForCheck()
              }
            })
          } catch (parseErr) {
            // Don't strand the user on a forever-skeleton if the rawData
            // shape is unexpected (missing custom fields, null salary, etc.).
            // Fall through to the not-available UI so they can navigate back.
            console.error('Failed to parse job detail', parseErr)
            this.isPublished = false
          }
        }
        this.isLoadingJob = false
        window.scrollTo(0, 0)

        if(!this.isPublished) {
          const notAvailable = this.notAvailableRef?.nativeElement as HTMLElement
          notAvailable?.classList.remove("scroll-fade")
          this.interval = setInterval(() => {
            this.time -= 1
            if (this.time <= 0) {
              clearInterval(this.interval)
              this.interval = undefined
              this.navigateTo("vacatures")
            }
            this.cdr.markForCheck()
          }, 1000)
        }
        this.cdr.markForCheck()
      },
      error: _ => {
        this.isLoadingJob = false
        this.isPublished = false
        this.cdr.markForCheck()
      }
    })
  }

  public get defaultJsonLD() {
    const obj = {
      "@context" : "https://schema.org/",
      "@type" : "JobPosting",
      "title" : "",
      "description" : "",
      "identifier": {
        "@type": "PropertyValue",
        "name": "Blauwtand",
        "value": ""
      },
      "datePosted" : "",
      "applicantLocationRequirements": {
        "@type": "Country",
        "name": "NL"
      },
      "employmentType" : "",
      "hiringOrganization" : {
        "@type" : "Organization",
        "name" : "Blauwtand",
        "sameAs" : "https://blauwtand.com"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
        "@type": "PostalAddress",
        "streetAddress": '',
        "addressLocality": "",
        "addressRegion": "",
        "postalCode": "",
        "addressCountry": "NL"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "EUR",
        "value": {
          "@type": "QuantitativeValue",
          "value": "",
          "unitText": "MONTH"
        }
      }
    }
    return this.getSafeHTML(obj)
  }

  public parseGoogleJob() {
    let employmentType = "FULL_TIME"

    switch(this.job.employment) {
      case employmentTypes[0]: employmentType = "FULL_TIME"; break
      case employmentTypes[1]: employmentType = "CONTRACTOR"; break
    }

    const salary = this.job.salary.static ? {
      "value": `${this.job.salary.static}`
    } : {
      "minValue": `${this.job.salary.min}`,
      "maxValue": `${this.job.salary.max}`,
    }

    const obj = {
      "@context" : "https://schema.org/",
      "@type" : "JobPosting",
      "title" : `${this.job.title}`,
      "description" : `${this.job.description}`,
      "identifier": {
        "@type": "PropertyValue",
        "name": "Blauwtand",
        "value": `${this.job.id}`
      },
      "datePosted" : `${this.job.publicationDate}`,
      "applicantLocationRequirements": {
        "@type": "Country",
        "name": "NL"
      },
      "employmentType" : `${employmentType}`,
      "hiringOrganization" : {
        "@type" : "Organization",
        "name" : "Blauwtand",
        "sameAs" : "https://blauwtand.com"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
        "@type": "PostalAddress",
        "streetAddress": '',
        "addressLocality": `${this.job.location.city}`,
        "addressRegion": `${this.job.location.state}`,
        "postalCode": `${this.job.location.postalCode}`,
        "addressCountry": "NL"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "EUR",
        "value": {
          "@type": "QuantitativeValue",
          ...salary,
          "unitText": "MONTH"
        }
      }
    }
    this.jsonLD = this.getSafeHTML(obj)
  }

  public viewJob(event: MouseEvent, job: JobCatsOne) {
    event.preventDefault()
    this.isLoadingJob = true
    this.isLoadingRelatedJobs = true
    this.relatedJobs = []
    this.sharedService.selectedJobId = job.id
    const slug = (job?.title || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')
  this.router.navigate([`vacatures`, `${slug}-${job.id}`])
    this.getJob(job.id)
  }

  public directApply(event: MouseEvent) {
    event.preventDefault()
    this.analytics.trackApplyImmediately();
    // Clear selected job context to avoid leaking IDs into unrelated routes
    this.sharedService.selectedJobId = undefined as any
  this.router.navigate(["solliciteren"], { relativeTo: this.activatedRoute })
  }

  private getSafeHTML(jsonLD: {[key: string]: any}): SafeHtml {
    const json = jsonLD ? JSON.stringify(jsonLD, null, 2).replace(/<\/script>/g, '<\\/script>') : ''; // escape / to prevent script tag in JSON
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  public backToJobs(): void {
    this.location.back()
  }

  public navigateTo(menuItem: string, isMobileMenu: boolean = false) {
    if (menuItem) {
      const lower = menuItem.toLowerCase()
      if (lower === 'home') {
        this.router.navigate(['/'])
      } else {
        this.router.navigate([`/${lower}`])
      }
    }
  }

  public ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = undefined
    }
  }

  private scrollFade(): void {
    const spinner = this.spinnerRef?.nativeElement as HTMLElement
    const viewJob = this.viewJobRef?.nativeElement as HTMLElement

    if(viewJob && viewJob.getBoundingClientRect().y < (window.innerHeight) && viewJob.classList.contains("scroll-fade")) {
      viewJob.classList.remove("scroll-fade")
    }

    if(spinner && spinner.getBoundingClientRect().y < (window.innerHeight + 200) && spinner.classList.contains("scroll-fade")) {
      spinner.classList.remove("scroll-fade")
    }
  }

  private buildJobSlug(title: string): string {
    const safe = (title ?? '').trim()
    if (!safe) { return 'vacature' }

    // Mirrors the slug logic used when navigating from the listing.
    return safe
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g,'')
      .replace(/[^a-z0-9]+/g,'-')
      .replace(/^-+|-+$/g,'')
  }

  private getCanonicalJobPath(job: JobCatsOne): string {
    const slug = this.buildJobSlug(job?.title)
    return `/vacatures/${slug}-${job?.id}`
  }

  private isLegacyJobUrlVariant(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0]
    return /^\/vacatures\/\d+$/.test(path) || /^\/vacatures\/bekijk-vacature\/\d+$/.test(path)
  }

  private maybeReplaceUrlWithCanonicalJobUrl(job: JobCatsOne): void {
    if (!job?.id) { return }
    if (!this.isLegacyJobUrlVariant()) { return }

    const canonicalPath = this.getCanonicalJobPath(job)
    const currentPath = this.router.url.split('?')[0].split('#')[0]
    if (canonicalPath && currentPath !== canonicalPath) {
      this.location.replaceState(canonicalPath)
    }
  }

  private setSeoForJob(job: JobCatsOne): void {
    const city = (job?.location?.city || '').trim()
    const metaDescription = this.vacancyMeta.buildMetaDescription({
      title: job?.title,
      city,
      descriptionHtml: job?.description,
      shortDescription: job?.shortDescription,
    })

    const jsonLdDescription = this.vacancyMeta.buildJsonLdDescription({
      descriptionHtml: job?.description,
      shortDescription: job?.shortDescription,
    })

    const canonicalPath = this.getCanonicalJobPath(job)
    const canonicalUrl = this.seo.generateCanonical(canonicalPath)
    const shouldNoIndexLegacy = this.isLegacyJobUrlVariant()

    this.seo.updateSeo({
      title: job?.title,
      description: metaDescription,
      ogType: 'article',
      imageUrl: undefined,
      ogImageAlt: job?.title,
      canonicalUrl,
      robots: !this.isPublished
        ? 'noindex,follow'
        : shouldNoIndexLegacy
          ? 'noindex,follow'
          : undefined
    })

    // Emit JobPosting JSON-LD
    if (this.isPublished) {
      const employmentType = job?.employment?.toUpperCase().includes('VAST') ? 'FULL_TIME' : 'CONTRACTOR'
      const datePosted = this.toSchemaDate(job?.publicationDate)
      const dateModified = this.toSchemaDate(job?.dateModified) ?? datePosted
      const jobPostingId = `${canonicalUrl}#jobposting`
      const organization = {
        '@type': 'Organization',
        name: 'Blauwtand',
        url: 'https://blauwtand.com/'
      }
      const data = {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'WebPage',
            '@id': canonicalUrl,
            url: canonicalUrl,
            name: job?.title,
            description: metaDescription,
            inLanguage: 'nl-NL',
            datePublished: datePosted,
            dateModified,
            author: organization,
            publisher: organization,
            mainEntity: { '@id': jobPostingId }
          },
          {
            '@type': 'JobPosting',
            '@id': jobPostingId,
            title: job?.title,
            description: jsonLdDescription,
            identifier: { '@type': 'PropertyValue', name: 'Blauwtand', value: `${job?.id}` },
            datePosted,
            employmentType,
            hiringOrganization: organization,
            jobLocation: {
              '@type': 'Place',
              address: {
                '@type': 'PostalAddress',
                addressLocality: job?.location?.city || '',
                addressRegion: job?.location?.state || '',
                postalCode: job?.location?.postalCode || '',
                addressCountry: 'NL'
              }
            },
            url: canonicalUrl,
            mainEntityOfPage: { '@id': canonicalUrl }
          }
        ]
      }
      this.seo.addJsonLd('jobposting', data)
    } else {
      this.seo.removeJsonLd('jobposting')
    }
  }

  private toSchemaDate(value: Date | string | null | undefined): string | undefined {
    if (!value) { return undefined }
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) { return String(value) }
    return date.toISOString()
  }
}
